<div class="marquee" *ngIf="visible" role="status">
  <div class="marquee__viewport">
    <div class="marquee__track">
      <span class="marquee__item" *ngFor="let message of messages">{{ message }}</span>
      <span class="marquee__item" *ngFor="let message of messages" aria-hidden="true">{{ message }}</span>
    </div>
  </div>
  <button type="button" class="marquee__close" (click)="dismiss()" title="Dismiss" aria-label="Dismiss announcement">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
</div>
